(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/playmaker-widget/assets/javascripts/playmaker-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/playmaker-widget/assets/javascripts/playmaker-widget.js');
"use strict";

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  getBetradarId
} = svs.components.oddset.kambiOffering;
const pmWidgetStyles = svs.components.lbLibs.playmaker.pmWidgetStyles;
const {
  liveDataSubscribe
} = svs.components.oddset.kambiOffering.liveData;
const logger = svs.core.log.getLogger('oddset-kambi:components:playmaker-widget');
class PlaymakerWidget extends HTMLElement {
  constructor() {
    super();
    _defineProperty(this, "updateTime", matchMinute => {
      var _this$spiderWidget, _this$xgLiveWidget, _this$liveWidget;
      if (matchMinute > 120) {
        matchMinute = 120;
      }
      (_this$spiderWidget = this.spiderWidget) === null || _this$spiderWidget === void 0 || _this$spiderWidget.updateTime(matchMinute);
      (_this$xgLiveWidget = this.xgLiveWidget) === null || _this$xgLiveWidget === void 0 || _this$xgLiveWidget.updateTime(matchMinute);
      (_this$liveWidget = this.liveWidget) === null || _this$liveWidget === void 0 || _this$liveWidget.updateTime(matchMinute);
    });
    _defineProperty(this, "onLiveDataUpdate", liveData => {
      if (liveData.matchClock && this.lastMatchMinute !== liveData.matchClock.minute) {
        this.lastMatchMinute = liveData.matchClock.minute;
        this.updateTime(liveData.matchClock.minute);
      }
    });
    _defineProperty(this, "onLiveDataError", error => {
      logger.error('Live data error', error);
    });
    this.spiderWidget = null;
    this.xgLiveWidget = null;
    this.liveWidget = null;
    this.lastMatchMinute = 0;
    this.livedataUnsubscribe = null;
  }
  static get observedAttributes() {
    return ['eventid', 'islive'];
  }
  get eventId() {
    return Number(this.getAttribute('eventid'));
  }
  get isEventLive() {
    return Boolean(this.getAttribute('islive'));
  }
  async connectedCallback() {
    var _liveData;
    const shadowRoot = this.attachShadow({
      mode: 'open'
    });
    const betradarId = await getBetradarId(this.eventId);
    if (!betradarId) {
      return;
    }
    const {
      unsubscribe,
      initialData
    } = liveDataSubscribe(this.eventId, this.onLiveDataUpdate, this.onLiveDataError);
    this.livedataUnsubscribe = unsubscribe;
    let liveData;
    try {
      liveData = await initialData;
    } catch (error) {
      logger.debug('No live data for event');
    }
    shadowRoot.innerHTML = "\n    <div class=\"pm-widget-container\">\n      <div class=\"pm-spider-container live\">\n        <div id=\"pm-live-widget-summary-".concat(betradarId, "\"></div>\n        <div id=\"pm-xg-live-widget-").concat(betradarId, "\"></div>\n        <div id=\"pm-live-widget-spider-").concat(betradarId, "\"></div>\n      </div>\n    </div>\n    ");
    const style = document.createElement('style');
    style.textContent = "\n      ".concat(pmWidgetStyles, "\n      .pm-widget-container {\n        margin-bottom: 30px;\n        padding-bottom: 21px;\n        background: #3b3737;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n        \n      .pm-spider-container {\n        width: 100%;\n        max-width: 366px;\n        display: block;\n        padding: 12px;\n      }");
    shadowRoot.appendChild(style);
    const liveContainer = shadowRoot.querySelector("#pm-live-widget-summary-".concat(betradarId));
    const xgContainer = shadowRoot.querySelector("#pm-xg-live-widget-".concat(betradarId));
    const spiderContainer = shadowRoot.querySelector("#pm-live-widget-spider-".concat(betradarId));
    const pm = window.PM;
    let matchMinute = (_liveData = liveData) === null || _liveData === void 0 || (_liveData = _liveData.matchClock) === null || _liveData === void 0 ? void 0 : _liveData.minute;
    if (Number.isInteger(matchMinute) && matchMinute > 120) {
      matchMinute = 120;
    }
    this.spiderWidget = pm('addLiveWidget', {
      matchId: betradarId,
      gameTime: this.isEventLive && Number.isInteger(matchMinute) ? matchMinute : undefined,
      containerElement: spiderContainer,
      settings: {
        kpis: [],
        theme: 'dark',
        renderRadar: true,
        autoUpdateScore: true
      }
    });
    this.xgLiveWidget = pm('addXgLiveWidget', {
      matchId: betradarId,
      gameTime: this.isEventLive && Number.isInteger(matchMinute) ? matchMinute : undefined,
      containerElement: xgContainer,
      settings: {
        theme: 'dark',
        renderLegend: false,
        autoUpdateScore: true
      }
    });
    this.liveWidget = pm('addLiveWidget', {
      matchId: betradarId,
      gameTime: this.isEventLive && Number.isInteger(matchMinute) ? matchMinute : undefined,
      containerElement: liveContainer,
      settings: {
        theme: 'dark',
        renderSummary: true,
        autoUpdateScore: true
      }
    });
  }
  disconnectedCallback() {
    var _this$livedataUnsubsc;
    (_this$livedataUnsubsc = this.livedataUnsubscribe) === null || _this$livedataUnsubsc === void 0 || _this$livedataUnsubsc.call(this);
  }
}
customElements.define('playmaker-widget', PlaymakerWidget);

 })(window);